import React from 'react'
import { Link } from 'react-router-dom'
import KarteraAdminTemplate from '../../../template/KarteraAdminTemplate'
import KarteraPageHeader from '../../../template/kartera/KarteraPageHeader'
import { ChevronRightIcon } from '../../../template/kartera/icons'
import { usePolicyImportMenuModel } from './policy-import-menu-model'

const PolicyImportMenu = () => {
    const model = usePolicyImportMenuModel()

    return (
        <KarteraAdminTemplate title="Importar pólizas">
            <div className="mx-auto flex w-full max-w-[880px] flex-col gap-[18px]">
                <KarteraPageHeader
                    title="Importar pólizas"
                    description="Integra tus pólizas a la cartera de forma masiva, desde sus carátulas o desde un Excel."
                />

                <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                    {model.options.map((option) => (
                        <Link
                            key={option.id}
                            to={option.to}
                            state={model.linkState}
                            className="group flex flex-col gap-4 rounded-2xl border border-k-line bg-k-surface p-5 hover:border-k-line-strong hover:bg-k-hover"
                        >
                            <span className={`flex h-14 w-14 items-center justify-center rounded-[16px] ${option.tone}`}>
                                <option.Icon style={{ fontSize: 30 }} />
                            </span>
                            <span className="flex flex-col gap-1">
                                <span className="flex items-center justify-between gap-2">
                                    <span className="text-base font-extrabold text-k-ink">{option.title}</span>
                                    <ChevronRightIcon className="shrink-0 text-k-muted-2 group-hover:text-brand-indigo" />
                                </span>
                                <span className="text-sm text-k-muted">{option.description}</span>
                            </span>
                            <span className="self-start rounded-full bg-k-line-soft px-2.5 py-0.5 text-xs font-bold text-k-ink-2">{option.hint}</span>
                        </Link>
                    ))}
                </div>
            </div>
        </KarteraAdminTemplate>
    )
}

export default PolicyImportMenu
